import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import DatePicker from "../../ui/DatePicker";

interface DatePickerState {
  startDate: string | undefined;
  setStartDate: any;
  endDate: string | undefined;
  setEndDate: any;
  dateInterval: number;
  setDateInterval: any;
  intervalOne: number;
  intervalOneText: string;
  intervalTwo: number;
  intervalTwoText: string;
  intervalThree: number;
  intervalThreeText: string;
  intervalFour: number;
  intervalFourText: string;
  onClickRefresh?: any;
  hideDates?: boolean;
  hideBtnId?: string;
  assessmentId?: string;
}

const ReportTimeInterval = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  dateInterval,
  setDateInterval,
  intervalOne,
  intervalOneText,
  intervalTwo,
  intervalTwoText,
  intervalThree,
  intervalThreeText,
  intervalFour,
  intervalFourText,
  onClickRefresh,
  hideDates = false,
  hideBtnId = "",
  assessmentId = "",
}: DatePickerState) => {
  const [timeOneActive, setTimeOneActive] = useState<boolean>(false);
  const [timeTwoActive, setTimeTwoActive] = useState<boolean>(false);
  const [timeThreeActive, setTimeThreeActive] = useState<boolean>(false);
  const [timeFourActive, setTimeFourActive] = useState<boolean>(true);
  const [refreshActive, setRefreshActive] = useState<boolean>(false);

  const updateTime = (time: string, interval: number) => {
    setDateInterval(interval);
    const start = new Date();
    start.setDate(start.getDate() - interval);
    setStartDate(start.toISOString().slice(0, 10));
    setEndDate(new Date().toISOString().slice(0, 10));

    if (assessmentId) {
      onClickRefresh(assessmentId, start.toISOString().slice(0, 10), new Date().toISOString().slice(0, 10));
    } else {
      onClickRefresh(start.toISOString().slice(0, 10), new Date().toISOString().slice(0, 10));
    }

    switch (time) {
      case "one":
        setTimeOneActive(true);
        setTimeTwoActive(false);
        setTimeThreeActive(false);
        setTimeFourActive(false);
        setRefreshActive(false);
        break;
      case "two":
        setTimeOneActive(false);
        setTimeTwoActive(true);
        setTimeThreeActive(false);
        setTimeFourActive(false);
        setRefreshActive(false);
        break;
      case "three":
        setTimeOneActive(false);
        setTimeTwoActive(false);
        setTimeThreeActive(true);
        setTimeFourActive(false);
        setRefreshActive(false);
        break;
      case "four":
        setTimeOneActive(false);
        setTimeTwoActive(false);
        setTimeThreeActive(false);
        setTimeFourActive(true);
        setRefreshActive(false);
        break;
      default:
        setTimeOneActive(true);
        setTimeTwoActive(false);
        setTimeThreeActive(false);
        setTimeFourActive(false);
        setRefreshActive(false);
        break;
    }
  };

  const onButtonClick = () => {
    setRefreshActive(true);
    setTimeOneActive(false);
    setTimeTwoActive(false);
    setTimeThreeActive(false);
    setTimeFourActive(false);
    if (assessmentId) {
      onClickRefresh(assessmentId, startDate, endDate);
    } else {
      onClickRefresh(startDate, endDate);
    }
  };

  return (
    <>
      {!hideDates && (
        <Row className="mt-3">
          <Col></Col>
          <Col xs={4} lg={3}>
            <DatePicker label="Start Date" currentValue={startDate} setCurrentValue={setStartDate} />
          </Col>
          <Col xs={4} lg={3}>
            <DatePicker label="End Date" currentValue={endDate} setCurrentValue={setEndDate} />
          </Col>
          <Col xs={3} lg={2} className="d-flex align-items-center">
            <Button
              id={hideBtnId}
              className={refreshActive ? "app-primary-color h-75 w-100 button" : "app-primary-color-inverse h-75 w-100 button"}
              onClick={() => onButtonClick()}
            >
              {"Refresh"}
            </Button>
          </Col>
          <Col></Col>
        </Row>
      )}
      <Row className={"d-flex justify-content-center mt-3 mb-4"}>
        <Col xs={3} lg={2} className="d-grid">
          <Button
            className={timeOneActive ? "app-secondary-color button" : "app-secondary-color-inverse button"}
            onClick={() => updateTime("one", intervalOne)}
          >
            {intervalOneText}
          </Button>
        </Col>
        <Col xs={3} lg={2} className=" d-grid">
          <Button
            className={timeTwoActive ? "button app-secondary-color button" : "app-secondary-color-inverse button"}
            onClick={(e) => updateTime("two", intervalTwo)}
          >
            {intervalTwoText}
          </Button>
        </Col>
        <Col xs={3} lg={2} className=" d-grid">
          <Button
            className={timeThreeActive ? "button app-secondary-color button" : "app-secondary-color-inverse button"}
            onClick={(e) => updateTime("three", intervalThree)}
          >
            {intervalThreeText}
          </Button>
        </Col>
        <Col xs={3} lg={2} className="d-grid">
          <Button
            className={timeFourActive ? "button app-secondary-color button" : "app-secondary-color-inverse button"}
            onClick={(e) => updateTime("four", intervalFour)}
          >
            {intervalFourText}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ReportTimeInterval;
